import React from 'react';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  note?: string;
  tone?: 'light' | 'dark';
  className?: string;
}
export function CtaButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  note,
  tone = 'light',
  className = ''
}: CtaButtonProps) {
  return <div className={className} data-id="element-162" data-mp="20w51olozqxl2">
      <a href={href} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : undefined} className="flex w-full items-center justify-center rounded-xl bg-gold px-4 py-3.5 text-center font-display text-[0.95rem] font-extrabold uppercase leading-tight text-navy shadow-[0_4px_0_var(--gold-shadow)] transition-[background-color,transform,box-shadow] duration-150 ease-soft hover:bg-gold-strong active:translate-y-[3px] active:shadow-[0_1px_0_var(--gold-shadow)] sm:text-lg" data-id="element-163" data-mp="1m55yjq6xd18v">
        {children}
      </a>
      {note && <p className={`mt-2 text-center font-display text-[0.7rem] font-bold sm:text-xs ${tone === 'dark' ? 'text-white/75' : 'text-graphite-muted'}`} data-id="element-164" data-mp="187hcwg519q2r">
          {note}
        </p>}
    </div>;
}